import { render, staticRenderFns } from "./PacksSearch.vue?vue&type=template&id=36b3173c&"
import script from "./PacksSearch.vue?vue&type=script&lang=js&"
export * from "./PacksSearch.vue?vue&type=script&lang=js&"
import style0 from "./PacksSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports